"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ntrMessagePrefix = void 0;
exports.ntrMessagePrefix = '[next-translate-routes-multi-domain] - ';
//# sourceMappingURL=withNtrPrefix.js.map